// Components
import WidgetAnalyticsPage from './widget-analytics';

// Logic
import WidgetAnalyticsLogic from '../../Logic/WidgetAnalytics';
import { URLS_PER_PAGE } from '../../Logic/WidgetAnalytics/config';
import { parseFiltersFromParams } from '../../Logic/WidgetAnalytics/filters';
import {
    emptyFilterOptions,
    emptyReport,
} from '../../Logic/WidgetAnalytics/report';

const withFallback = (request, fallback) =>
    request.then(
        (value) => ({ value, error: null }),
        (error) => {
            console.error('Widget analytics request failed', error);
            return { value: fallback(), error: 'Could not load widget analytics. Please try again.' };
        },
    );

export default {
    name: 'widget-analytics',
    url: '/widget-analytics/?{account_id}&{widget_id}&{date_from}&{date_to}&{page}',
    component: WidgetAnalyticsPage,
    resolve: [
        {
            token: 'filters',
            deps: ['$transition$'],
            resolveFn: (trans) => parseFiltersFromParams(trans.params()),
        },
        {
            token: 'filterOptionsResult',
            deps: ['filters'],
            resolveFn: (filters) =>
                withFallback(
                    WidgetAnalyticsLogic.getFilterOptions(filters.accountId),
                    emptyFilterOptions,
                ),
        },
        {
            token: 'filterOptions',
            deps: ['filterOptionsResult'],
            resolveFn: (result) => result.value,
        },
        {
            token: 'reportResult',
            deps: ['filters'],
            resolveFn: (filters) =>
                withFallback(
                    WidgetAnalyticsLogic.getReport(filters, URLS_PER_PAGE),
                    emptyReport,
                ),
        },
        {
            token: 'report',
            deps: ['reportResult'],
            resolveFn: (result) => result.value,
        },
        {
            token: 'error',
            deps: ['reportResult', 'filterOptionsResult'],
            resolveFn: (report, options) => report.error || options.error,
        },
    ],
};
